
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bccdgawjwhzbvcaxjtzz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJjY2RnYXdqd2h6YnZjYXhqdHp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY2MTc3NTIsImV4cCI6MjA1MjE5Mzc1Mn0.OW2IwLmkpWhijQ5zncNFpG9gZJnyiMstANDMNz9u97Q";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      // Use native localStorage so Supabase can read/write the session token correctly
      storage: localStorage,
    },
    realtime: {
      params: {
        eventsPerSecond: 1,
      },
    },
    db: {
      schema: 'public',
    },
    global: {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'authorization, x-client-info, apikey, content-type',
      },
    },
  }
);

export default supabase;
